import { render, staticRenderFns } from "./five.vue?vue&type=template&id=51e139b6&"
import script from "./five.vue?vue&type=script&lang=js&"
export * from "./five.vue?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports